var PREFIX_FOR_TEST_IDS = 'federal-testimony-form';

/** test ids for form and sections inside it */
export var TestIds = {
  FEDERAL_TESTIMONY_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  FEDERAL_TESTIMONY_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-federal-testimony-pub-info-sec-test-id")
};
export var SECTION_TITLE = 'publication info';